import { render, staticRenderFns } from "./productstrain.vue?vue&type=template&id=315abf41&"
import script from "./productstrain.vue?vue&type=script&lang=js&"
export * from "./productstrain.vue?vue&type=script&lang=js&"
import style0 from "./productstrain.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports